
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Code, Lightbulb, Heart } from 'lucide-react';
import type { Tables } from '@/integrations/supabase/types';

type Candidate = Tables<'candidates'>;

interface CandidateSkillsInfoProps {
  candidate: Candidate;
}

export function CandidateSkillsInfo({ candidate }: CandidateSkillsInfoProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Code className="h-5 w-5" />
          Skills & Interests
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {candidate.key_skills && candidate.key_skills.length > 0 && (
          <div>
            <h4 className="font-medium mb-3 flex items-center gap-2">
              <Lightbulb className="h-4 w-4" />
              Key Skills
            </h4>
            <div className="flex flex-wrap gap-2">
              {candidate.key_skills.map((skill, index) => (
                <span key={index} className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm">
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}

        {candidate.technologies && candidate.technologies.length > 0 && (
          <div>
            <h4 className="font-medium mb-3 flex items-center gap-2">
              <Code className="h-4 w-4" />
              Technologies
            </h4>
            <div className="flex flex-wrap gap-2">
              {candidate.technologies.map((tech, index) => (
                <span key={index} className="bg-secondary/50 text-secondary-foreground px-3 py-1 rounded-full text-sm">
                  {tech}
                </span>
              ))}
            </div>
          </div>
        )}

        {candidate.hobbies_interests && candidate.hobbies_interests.length > 0 && (
          <div>
            <h4 className="font-medium mb-3 flex items-center gap-2">
              <Heart className="h-4 w-4" />
              Hobbies & Interests
            </h4>
            <div className="flex flex-wrap gap-2">
              {candidate.hobbies_interests.map((hobby, index) => (
                <span key={index} className="bg-muted text-muted-foreground px-3 py-1 rounded-full text-sm">
                  {hobby}
                </span>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
